import { OfflineInfoPc } from './OfflineInfo/OfflineInfo.pc';
import { OfflineInfoMobile } from './OfflineInfo/OfflineInfo.mobile';
import { useIsMobile } from '../../../hook/useIsMobile';

export const OfflineInfo = () => {
  const isMobile = useIsMobile();
  return isMobile ? <OfflineInfoMobile /> : <OfflineInfoPc />;
};
